import { render, staticRenderFns } from "./aShop.vue?vue&type=template&id=12c7e56c&scoped=true"
import script from "./aShop.vue?vue&type=script&lang=js"
export * from "./aShop.vue?vue&type=script&lang=js"
import style0 from "./aShop.vue?vue&type=style&index=0&id=12c7e56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7e56c",
  null
  
)

export default component.exports